import { BULK_EDIT_DRAWER_UPDATE_CREATIVES_SUCCESS } from './actionTypes';

export const bulkEditDrawerUpdateCreativesSuccess = creatives => ({
    type: BULK_EDIT_DRAWER_UPDATE_CREATIVES_SUCCESS,
    payload: creatives,
});
